export default {
  initialized: false,
  categories: [],
  manufacturers: [],
  items: [],
  templates: []
};
